module.exports = __webpack_public_path__ + "static/media/questions-icon.85f87708.svg";